import { fetcherFactory } from "./fetcher";
import { getEnvironmentVariables } from "../utils/general";
import { getPreferredMfaFactor, type MfaFactor, type MfaPreference } from "../utils/mfa";

const { basePath } = getEnvironmentVariables();
const fetcher = fetcherFactory();

export type MfaLoginPreferenceResponse = {
  enabled_factors: MfaFactor[]
  preferred_factor?: MfaPreference | "" | null
}

// Endpoint di prelogin: riceve corporate_id nel path ed external_id in query, senza password o Session Cognito.
const getMfaLoginPreferenceUri = (corporateId: number) => `/usermgmt/corporate/${corporateId}/user/mfa-status`;

/** Una preferenza assente/non valida o un BE non disponibile lasciano la scelta all'utente. */
export async function getMfaLoginPreference(externalId: string, corporateId: number): Promise<MfaFactor | null> {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);

  try {
    const uri = `${basePath}${getMfaLoginPreferenceUri(corporateId)}?external_id=${encodeURIComponent(externalId)}`;
    const response = await fetcher(uri, {
      cache: "no-store",
      headers: {
        "Accept": "application/json"
      },
      method: "GET",
      signal: controller.signal
    });
    const data: MfaLoginPreferenceResponse | null = await response.json();
    return getPreferredMfaFactor(data?.preferred_factor);
  } catch {
    return null;
  } finally {
    clearTimeout(timeout);
  }
}
